export interface Search {
    searchInput?: string;
    duration?: string;
    category?: string;
    country_of_origin?: string[];
  }